import { t } from '@lingui/macro';
const thousand = Math.pow(10, 3);
const millions = Math.pow(10, 6);

const getRoundedNumberWithSymbol = (value?: number) => {
    if (typeof value === 'undefined') {
        return '';
    }

    let symbol = '';
    let divisor = 1;

    switch (true) {
        case value >= millions:
            symbol = t({ comment: 'unit symbol for millions', message: `M` });
            divisor = millions;
            break;

        case value >= thousand:
            symbol = t({ comment: 'unit symbol for thousands', message: `K` });
            divisor = thousand;
            break;

        default:
            break;
    }

    const quotient = value / divisor;
    const decimal = quotient < 10 ? 10 : 1;
    const trunc = Math.trunc(quotient * decimal) / decimal;

    return `${Number(trunc)}${symbol}`;
};

export default getRoundedNumberWithSymbol;
